<template>
  <div class="dict">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"> <span></span>{{ title }} </div>
        </template>
        <div class="collapse-content">
          <baseInfo
            v-bind:accruedInfo="accruedInfo"
            :canEdit="canEdit"
            :transferType="flag"
            :currencyList="currencyList"
            :companyList="companyList"
            ref="accruedInfo"
          />
        </div>
      </el-collapse-item>
      <div class="m-b">
        <el-tabs type="card" v-model="activeNameTab" class="common-tab">
          <el-tab-pane name="voucherTab" :label="$t('addInvoice.invoiceLine.title2')">
            <voucher
              ref="voucher"
              :voucherList="voucherList"
              @reverseInfo="reverseInfo"
              @postInfo="postInfo"
              @doConfirmInfo="doConfirmInfo"
            ></voucher>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!--编辑 -->
      <el-button
        v-hasPermi="['2021111917322355746']"
        :disabled="['', 'saved', 'withdrawn', 'rejected'].indexOf(accruedInfo.transferStatus) == -1"
        type="primary"
        @click="edit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.edit') }}</el-button
      >
      <!-- 保存 -->
      <el-button
        :disabled="
          ['', 'saved', 'withdrawn', 'rejected'].indexOf(accruedInfo.transferStatus) == -1 ||
          !canEdit
        "
        type="primary"
        v-hasPermi="['2021111917323018285']"
        @click="save"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.save') }}</el-button
      >
      <el-button
        :disabled="['saved', 'withdrawn', 'rejected'].indexOf(accruedInfo.transferStatus) == -1"
        type="primary"
        v-hasPermi="['2021111917324164149']"
        @click="submit()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.submit') }}</el-button
      >
      <el-button
        :disabled="['approved'].indexOf(accruedInfo.transferStatus) == -1"
        v-hasPermi="['2021111917324878133']"
        type="primary"
        @click="doConfirm"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.confirm') }}</el-button
      >
      <!-- 生成凭证 只有已确认状态才能点击生成凭证按钮。-->
      <el-button
        :disabled="
          ['confirmed'].indexOf(accruedInfo.transferStatus) == -1 ||
          ['notgenerate', 'generated', 'postError'].indexOf(accruedInfo.accountingStatus) == -1
        "
        v-hasPermi="['2021111917330109873']"
        type="primary"
        @click="handleAccountEntry"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.generateCredentials') }}</el-button
      >
      <!-- 过账凭证 只有已确认状态才能点击生成凭证按钮。-->
      <el-button
        :disabled="
          ['confirmed'].indexOf(accruedInfo.transferStatus) == -1 ||
          ['generated', 'postError'].indexOf(accruedInfo.accountingStatus) == -1
        "
        v-hasPermi="['2021111917331043865']"
        type="primary"
        @click="doSyncVoucherForEntityData()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.doSyncVoucher') }}</el-button
      >
      <!-- 撤回 只有单据状态为“已通过”的预提单才能点击该按钮-->
      <el-button
        :disabled="['approved'].indexOf(accruedInfo.transferStatus) == -1"
        v-hasPermi="['2021111917332207684']"
        type="primary"
        @click="doWithdraw"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.doWithdraw') }}</el-button
      >
      <!-- 冲销 单据状态为：已确认的单据才能点击冲销按钮。-->
      <el-button
        :disabled="['confirmed'].indexOf(accruedInfo.transferStatus) == -1"
        v-hasPermi="['2021111917332894530']"
        type="primary"
        @click="doReverseAccountEntry()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.writeOff') }}</el-button
      >
    </div>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/financeCenter/transfer';
  import DataBaseAPI from '@/api/dataBase';
  import baseInfo from './components/baseInfo';
  import loading from '@/common/js/load.js'; //loading
  // import baseForm from '@/components/form/base-form';
  import voucherMixins from '@/common/mixins/voucher.js';

  export default {
    components: {
      baseInfo,
      // baseForm,
    },
    name: 'transferAdd',
    mixins: [voucherMixins],
    data() {
      // const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        voucherFlag: 'AE_AP_TRANSFER', //凭证标识
        activeNameTab: 'voucherTab',
        load: false,
        flag: this.$route.query.transferType,
        activeNames: ['1', '2'],
        accruedInfo: {
          transferStatus: '', //单据状态
        },
        companyList: [], //公司列表
        departmentList: [], // 部门列表
        dialogVisible: false,
        canEdit: false,
        title: '创建转款单',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        currencyList() {
          return this.$baseRequest.getDictListByType('all_currency');
        },
      }),
      reverseDataOptions() {
        return [
          {
            //冲销原因
            prop: 'reverseReason',
            span: 12,
            label: this.$t('withholdingList.withholdInfoAdd.column.accountingStatus'),
            type: 'dict',
            dictType: 'reverse_reason',
            clearable: true,
            required: true,
          },
          {
            // 冲销入账日期
            prop: 'reversePostDate',
            type: 'date',
            span: 12,
            label: this.$t('withholdingList.withholdInfoAdd.column.reversePostDate'),
            clearable: true,
            disabled: this.reverseData.reverseReason == 'N',
          },
        ];
      },
    },
    mounted() {
      this.getCompany();
      if (this.$route.query.id) {
        this.getTitle('编辑');
        this.getDetail(this.$route.query.id);
      } else {
        this.getTitle('创建');
        this.$refs.accruedInfo.formData.transferType = this.flag;
        if (this.flag == 'TT01') {
          this.$refs.accruedInfo.formData.originPartnerType = 'HZHB02';
          this.$refs.accruedInfo.formData.transferPartnerType = 'HZHB02';
        } else if (this.flag == 'TT02') {
          this.$refs.accruedInfo.formData.originPartnerType = 'HZHB01';
          this.$refs.accruedInfo.formData.transferPartnerType = 'HZHB01';
        } else if (this.flag == 'TT03') {
          this.$refs.accruedInfo.formData.originPartnerType = 'HZHB02';
          this.$refs.accruedInfo.formData.transferPartnerType = 'HZHB01';
        }
        this.canEdit = this.$route.query.type == 'add';
      }
    },
    methods: {
      // 获取详情信息
      getDetail(id = this.accruedInfo['id']) {
        loading.startLoading();
        let api = API.TRANSFER_QUERYBYID;
        this.$axios
          .post(`${api}`, { id: id })
          .then((res) => {
            loading.endLoading();
            if (0 == res.data.code) {
              // 获取凭证ID 获取凭证列表
              this.entityDataId = id;
              this.getAccountEntry();
              this.accruedInfo = res.data.data;
              this.$refs.accruedInfo.formData = res.data.data;
              this.$refs['accruedInfo'].getdepartmentList(this.accruedInfo.businessCompanyCode);
            } else {
              this.$alert(res.data.msg);
            }
          })
          .catch(() => loading.endLoading());
      },
      //获取公司信息
      async getCompany() {
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          let personCompanyInfo = selectStatus.data.data.personCompanyInfo || [];
          if (personCompanyInfo[0]) {
            this.companyList = personCompanyInfo.map((it) => {
              return { value: it.personCompanyCode, label: it.personCompanyName };
            });
          }
        }
      },
      // 获取标题
      getTitle(str) {
        if (this.flag == 'TT01') {
          this.title = str + '付款转款';
        } else if (this.flag == 'TT02') {
          this.title = str + '收款转款';
        } else if (this.flag == 'TT03') {
          this.title = str + '抹账';
        }
      },
      // 校验表单
      validateForm() {
        return new Promise((resolve) => {
          this.$refs.accruedInfo.$refs.formData.handleSubmit().then(() => {
            resolve(true);
          });
        });
      },
      // 编辑
      edit() {
        this.canEdit = true;
      },
      //保存
      async save() {
        let flag = await this.validateForm(); //校验表单
        if (!flag) return;
        let params = {
          ...this.$refs.accruedInfo.formData,
        };
        params = this.$baseRequest.assignObj(params);
        this.saveData(params);
      },
      async saveData(params) {
        loading.startLoading();
        let res = await this.$axios.post(API.TRANSFER_SAVE, params);
        if (res) {
          loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.saveSussess'),
            });
            this.getDetail(res.data.data.id);
          } else {
            this.$message({ showClose: true, type: 'error', message: res.data.msg });
          }
        } else {
          loading.endLoading();
        }
      },
      //提交审批
      async submit(cancelValidate) {
        let flag = await this.validateForm(); //校验表单
        if (!flag) return;
        let params = {
          ...this.$refs.accruedInfo.formData,
        };
        params = this.$baseRequest.assignObj(params);
        loading.startLoading();
        this.$axios
          .post(API.TRANSFER_SUBMIT_APPROVAL, { ...params, cancelValidate })
          .then((res) => {
            loading.endLoading();
            if (res.data.code === 0) {
              this.$message({ showClose: true, message: '提交审批成功', type: 'success' });
              this.goBack();
            } else if (res.data.code === 10) {
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  //确认提交，cancelValidate传值true取消校验
                  this.submit(true);
                },
              });
            } else {
              if (res.data.data) {
                this.getDetail(res.data.data.id);
              }
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .catch(() => loading.endLoading());
      },
      // async delet(){
      //   this.params ={docNo:this.accruedInfo.docNo};
      //   this.$confirmAction().then(() => {
      //       this.$axios.post(API.TRANSFER_DELETE, params).then(res => {
      //       if (0 == res.data.code) {
      //         this.$message({ showClose: true,  message: res.data.msg,  type: "success"  });
      //         this.goBack();
      //       } else {
      //         this.$alert(res.data.msg);
      //       }
      //     });
      //   })
      // },
      // 确认
      doConfirmInfo(info) {
        loading.startLoading();
        let params = { id: this.accruedInfo.id, ...info };
        this.$axios
          .post(API.DO_CONFIRM, params)
          .then((res) => {
            loading.endLoading();
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t('message.success'),
                type: 'success',
              });
              this.getDetail(this.accruedInfo.id);
            } else if (res.data.code === 10) {
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  //确认提交，cancelValidate传值true取消校验
                  this.doConfirmInfo({ ...info, cancelValidate: true });
                },
              });
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .catch(() => loading.endLoading());
      },
      // 撤回
      async doWithdraw() {
        const params = {
          id: this.accruedInfo.id,
        };
        loading.startLoading();
        this.$axios
          .post(API.TRANSFER_WITHDRAW, params)
          .then((res) => {
            loading.endLoading();
            if (res.data.code == 0) {
              this.getDetail(this.accruedInfo.id);
            } else {
              this.$message({ showClose: true, type: 'error', message: res.data.msg });
            }
          })
          .catch(() => loading.endLoading());
      },
      //冲销
      async writeOff() {
        if (
          this.accruedInfo.accountingStatus != 'notgenerate' &&
          this.accruedInfo.reverseStatus == 'N'
        ) {
          this.dialogVisible = true;
        } else {
          loading.startLoading();
          this.$axios
            .post(API.TRANSFER_GENARATE_VOUCHER, { id: this.accruedInfo.id })
            .then((res) => {
              loading.endLoading();
              if (0 == res.data.code) {
                this.closeDialog();
                this.getDetail(this.accruedInfo.id);
              } else {
                this.$alert(res.data.msg);
              }
            })
            .catch(() => loading.endLoading());
        }
      },
      closeDialog() {
        this.dialogVisible = false;
        // this.postDate = null;
      },
      selectTrue() {
        const accrued = {
          id: this.accruedInfo.id,
          reverseReason: this.reverseData.reverseReason, //冲销原因
          reversePostDate: this.reverseData.reversePostDate, //冲销日期
        };
        this.loading.startLoading();
        this.$axios.post(API.REVERSE_VOUCHER, accrued).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.closeDialog();
            this.getDetail(this.accruedInfo.id);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 返回
      goBack() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: '转款单编辑',
            },
          },
          toPath: {
            path: '/transfer/list',
            name: 'transferList',
            meta: {
              keepAlive: true,
              title: '转款单查询',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>
